/*
 * "Haber ver" — back-in-stock emails (owner 2026-10-12).
 *   <haber-ver>             product page box under the add-to-cart button (snippets/haber-ver-product.liquid)
 *   [data-haber-ver-list]   Hesabım → "Haber ver listem" (snippets/account-haber-ver.liquid)
 * Back end: points API (ghisa-points-api routers/restock.py). The logged-in customer is proven by the
 * storefront signature the Liquid renders; guests give an email.
 * Theme setting "Yalnız test hesapları": test accounts see it; anyone can add ?haber-ver-test=1 to a URL to
 * see the guest box on this browser (?haber-ver-test=0 to stop).
 */
(function () {
  var TIMEOUT_MS = 30000;
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

  try {
    var flag = new URLSearchParams(location.search).get('haber-ver-test');
    if (flag === '1') localStorage.setItem('haberVerTest', '1');
    if (flag === '0') localStorage.removeItem('haberVerTest');
  } catch (e) { /* storage unavailable */ }
  function testOpen() {
    try { return localStorage.getItem('haberVerTest') === '1'; } catch (e) { return false; }
  }

  function call(api, path, body) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    return fetch(api.replace(/\/+$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data || {} };
      });
    }, function () {
      return { ok: false, status: 0, data: {} };
    }).finally(function () { if (timer) clearTimeout(timer); });
  }

  function message(r) {
    if (r.status === 401) return 'Oturumunuzun yenilenmesi gerekiyor. Lütfen sayfayı yenileyip tekrar deneyin.';
    if (r.status === 0) return 'Bağlantı kurulamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.';
    return r.data.detail || 'Bir sorun oluştu. Lütfen birkaç dakika sonra tekrar deneyin.';
  }

  // The storefront signature: a JSON script block inside the box / list (snippets/storefront-identity.liquid),
  // not data-* attributes (c93 security review M1). None → guest.
  function identity(node) {
    var script = node.querySelector('script[data-storefront-identity]');
    var me = null;
    try { me = script ? JSON.parse(script.textContent) : null; } catch (e) { me = null; }
    return me && me.sig ? { shopify_customer_id: me.shopify_customer_id, ts: me.ts, sig: me.sig } : {};
  }

  function tl(amount) {
    var v = Number(amount);
    if (!isFinite(v) || !amount) return '';
    var whole = Math.floor(v) === v;
    return v.toLocaleString('tr-TR', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function day(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'class') node.className = attrs[k];
      else if (attrs[k] != null && attrs[k] !== false) node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  /* ── Product page box ─────────────────────────────────────────────────── */

  if (!customElements.get('haber-ver')) {
    customElements.define('haber-ver', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        if (this.dataset.gate !== 'open' && !testOpen()) return;
        this.loggedIn = !!identity(this).sig;
        this.variantId = this.dataset.variantId;
        this.available = this.dataset.available === 'true';
        this.sizeIndex = this.dataset.sizeIndex === '' ? -1 : Number(this.dataset.sizeIndex);
        this.done = {};
        this.form = this.querySelector('[data-hv-form]');
        this.msg = this.querySelector('[data-hv-msg]');
        this.button = this.querySelector('[data-hv-submit]');
        this.email = this.querySelector('[data-hv-email]');
        this.emailFallback = this.querySelector('[data-hv-email-fallback]');
        this.sizeLabel = this.querySelector('[data-hv-size-label]');
        var self = this;
        document.addEventListener('product:variant-change', function (e) {
          var d = (e && e.detail) || {};
          if (d.sectionId && d.sectionId !== self.dataset.section) return;
          self.setVariant(d.variant);
        });
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
        this.render(this.checkedLabel() || null);
      }

      setVariant(variant) {
        if (!variant) { this.hidden = true; return; }
        this.variantId = String(variant.id);
        this.available = !!variant.available;
        var size = this.sizeIndex >= 0 && variant.options ? variant.options[this.sizeIndex] : '';
        this.render(this.pickerLabel(size) || size);
      }

      // The selected size's label on page load (e.g. opened from a link with ?variant=).
      checkedLabel() {
        var picker = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]');
        var fieldset = picker && picker.querySelectorAll('fieldset')[this.sizeIndex];
        var input = fieldset && fieldset.querySelector('input:checked');
        return input ? this.pickerLabel(input.value) : '';
      }

      // The size as the picker shows it ("1/38-40"), not the raw option value ("1").
      pickerLabel(value) {
        var picker = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]');
        var fieldset = picker && picker.querySelectorAll('fieldset')[this.sizeIndex];
        if (!fieldset) return '';
        var input = Array.prototype.find.call(fieldset.querySelectorAll('input'), function (i) { return i.value === value; });
        var label = input && fieldset.querySelector('label[for="' + input.id + '"]');
        return label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      }

      render(size) {
        this.hidden = this.available;
        if (this.available) return;
        if (size != null) this.sizeLabel.textContent = size ? size + ' beden' : 'Bu beden';
        var done = this.done[this.variantId];
        this.form.hidden = !!done;
        this.querySelector('.haber-ver__text').hidden = !!done;
        this.showMessage(done || '', !!done);
      }

      showMessage(html, ok) {
        this.msg.hidden = !html;
        this.msg.classList.toggle('is-ok', !!ok);
        this.msg.innerHTML = html;
      }

      submit() {
        if (this.busy) return;
        var body = { variant_id: this.variantId };
        var typed = this.email || (this.emailFallback && !this.emailFallback.hidden ? this.emailFallback : null);
        var email = typed ? typed.value.trim() : '';
        if (typed && !EMAIL_RE.test(email)) {
          this.showMessage('Lütfen geçerli bir e-posta adresi yazın.', false);
          typed.focus();
          return;
        }
        if (email) body.email = email;
        Object.assign(body, identity(this));
        this.busy = true;
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        var self = this;
        var variantId = this.variantId;
        call(this.dataset.api, '/api/restock/subscribe', body).then(function (r) {
          self.busy = false;
          self.button.disabled = false;
          self.button.classList.remove('is-loading');
          if (r.ok) {
            var to = r.data.email || email;
            var text = (r.data.already ? 'Bu beden zaten listenizde. ' : 'Listenize eklendi. ') +
              'Stoğa girince <b>' + escapeHtml(to) + '</b> adresine e-posta göndereceğiz.';
            if (self.loggedIn) text += ' <a href="/account#haber-ver">Haber ver listem</a>';
            self.done[variantId] = text;
            if (variantId === self.variantId) self.render(null);
            return;
          }
          if (r.status === 400 && r.data.field === 'email' && self.emailFallback) {
            self.emailFallback.hidden = false;
            self.emailFallback.focus();
          }
          self.showMessage(escapeHtml(message(r)), false);
        });
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Hesabım → Haber ver listem ───────────────────────────────────────── */

  function initList(root) {
    var started = false;
    var items = root.querySelector('[data-hv-items]');
    var empty = root.querySelector('[data-hv-empty]');
    var loading = root.querySelector('[data-hv-loading]');
    var error = root.querySelector('[data-hv-error]');
    var foot = root.querySelector('[data-hv-foot]');
    var api = root.dataset.api;

    function fail(r) {
      loading.hidden = true;
      error.hidden = false;
      error.textContent = message(r);
    }

    function refreshEmpty() {
      empty.hidden = items.children.length > 0;
    }

    function detail(item) {
      var parts = [];
      if (item.color) parts.push('Renk: ' + item.color);
      if (item.size) parts.push('Beden: ' + item.size);
      return parts.join(' · ');
    }

    function badge(item) {
      if (item.status === 'waiting') {
        return item.available
          ? ['ok', 'Stokta — hemen alabilirsiniz']
          : ['', 'Bekleniyor · ' + day(item.created_at) + "'den beri"];
      }
      return item.available === false
        ? ['warn', 'Haber verildi ' + day(item.notified_at) + ' · yeniden tükendi']
        : ['ok', 'Haber verildi ' + day(item.notified_at) + ' · stokta'];
    }

    function row(item) {
      var b = badge(item);
      var note = el('p', { class: 'haber-ver-list__note', role: 'status', hidden: true });
      var actions = el('span', { class: 'haber-ver-list__actions' });
      var card = el('div', { class: 'haber-ver-list__item', 'data-id': item.id }, [
        el('a', { class: 'haber-ver-list__thumb', href: item.url, 'aria-hidden': 'true', tabindex: '-1' }, [
          item.image ? el('img', { src: item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200', alt: '', loading: 'lazy', width: '72', height: '96' }) : null
        ]),
        el('span', { class: 'haber-ver-list__body' }, [
          el('a', { class: 'haber-ver-list__title', href: item.url, text: item.title || '' }),
          detail(item) ? el('span', { class: 'haber-ver-list__detail', text: detail(item) }) : null,
          el('span', { class: 'haber-ver-list__badge' + (b[0] ? ' haber-ver-list__badge--' + b[0] : ''), text: b[1] }),
          tl(item.price) ? el('span', { class: 'haber-ver-list__price', text: tl(item.price) }) : null,
          actions,
          note
        ])
      ]);

      function say(text, ok) {
        note.hidden = !text;
        note.textContent = text || '';
        note.classList.toggle('is-ok', !!ok);
      }

      if (item.available) {
        var add = el('button', { type: 'button', class: 'haber-ver-list__btn', text: 'Sepete ekle' });
        add.addEventListener('click', function () {
          add.disabled = true;
          var routes = (window.theme && window.theme.routes) || {};
          fetch((routes.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(item.variant_id), quantity: 1 }] })
          }).then(function (res) {
            if (!res.ok) throw res;
            add.textContent = 'Sepete eklendi';
            say('', false);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }).catch(function () {
            add.disabled = false;
            say('Sepete eklenemedi; bu beden az önce tükenmiş olabilir.', false);
          });
        });
        actions.appendChild(add);
      }
      if (item.status === 'notified' && item.available === false) {
        var again = el('button', { type: 'button', class: 'haber-ver-list__btn', text: 'Yeniden haber ver' });
        again.addEventListener('click', function () {
          again.disabled = true;
          call(api, '/api/restock/subscribe', Object.assign({ variant_id: item.variant_id }, identity(root))).then(function (r) {
            if (r.ok) { load(); return; }
            again.disabled = false;
            say(message(r), false);
          });
        });
        actions.appendChild(again);
      }
      if (item.status === 'waiting') {
        var remove = el('button', { type: 'button', class: 'haber-ver-list__link', text: 'Listeden çıkar' });
        remove.addEventListener('click', function () {
          remove.disabled = true;
          call(api, '/api/restock/cancel', Object.assign({ id: item.id }, identity(root))).then(function (r) {
            if (r.ok || r.status === 404) {
              card.remove();
              refreshEmpty();
              return;
            }
            remove.disabled = false;
            say(message(r), false);
          });
        });
        actions.appendChild(remove);
      }
      return card;
    }

    function load() {
      started = true;
      error.hidden = true;
      if (!api || !identity(root).sig) { fail({ status: 500, data: {} }); return; }
      call(api, '/api/restock/list', identity(root)).then(function (r) {
        if (!r.ok) { fail(r); return; }
        loading.hidden = true;
        items.innerHTML = '';
        (r.data.items || []).forEach(function (item) { items.appendChild(row(item)); });
        refreshEmpty();
        foot.hidden = !r.data.email || !items.children.length;
        foot.textContent = r.data.email ? 'E-postalar ' + r.data.email + ' adresine gider.' : '';
      });
    }

    function start() { if (!started) load(); }
    var tab = document.querySelector('[data-tab="haber-ver"]');
    if (tab) tab.addEventListener('click', start);
    var panel = root.closest('.account-tabs__panel');
    if (panel && !panel.hidden) start();
    // /account#haber-ver (the email's link): open the tab where the account page doesn't route hashes itself
    if (location.hash === '#haber-ver' && tab) {
      var open = function () {
        setTimeout(function () { if (panel && panel.hidden) tab.click(); start(); }, 50);
      };
      if (document.readyState === 'complete') open(); else window.addEventListener('load', open);
    }
  }

  function boot() {
    document.querySelectorAll('[data-haber-ver-list]').forEach(initList);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
